import React from 'react';

export const IconPartnerMolecule = () => {
  return (
    <div className="w-full max-w-24 pr-2 lg:pr-3.5">
      <div className="block lg:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98.774 99.629">
          <g
            id="Group_1134"
            data-name="Group 1134"
            transform="translate(-773.57 -931.842)"
          >
            <g
              id="Group_662"
              data-name="Group 662"
              transform="translate(756.326 163.786)"
            >
              <text
                id="_50_"
                data-name="50%"
                transform="translate(53.273 815.187)"
                fill="#fff"
                fontSize="17.2"
                className="waldo-sans font-normal text-h_5"
                letterSpacing="0.04em"
              >
                <tspan x="0" y="0">
                  50%
                </tspan>
              </text>
              <text
                id="patients"
                transform="translate(49 827.935)"
                fill="#fff"
                fontSize="12"
                className="waldo-sans font-semibold text-xs"
              >
                <tspan x="0" y="0">
                  patients
                </tspan>
              </text>
            </g>
            <g id="Group_1133" data-name="Group 1133">
              <g
                id="Group_1024"
                data-name="Group 1024"
                transform="translate(0 -116.655)"
              >
                <g
                  id="Group_665"
                  data-name="Group 665"
                  transform="translate(759.07 290.245)"
                  opacity="0.5"
                >
                  <path
                    id="Path_677"
                    data-name="Path 677"
                    d="M48.887,0A49.317,49.317,0,1,1,0,49.315,49.1,49.1,0,0,1,48.887,0Z"
                    transform="translate(15 758.752)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="1"
                  />
                </g>
                <path
                  id="Path_436"
                  data-name="Path 436"
                  d="M-341.939,8.122A34.061,34.061,0,0,1-376-25.939,34.061,34.061,0,0,1-341.939-60"
                  transform="translate(1164.486 1124.25)"
                  fill="none"
                  stroke="#fff"
                  strokeMiterlimit="10"
                  strokeWidth="15"
                />
                <path
                  id="Path_746"
                  data-name="Path 746"
                  d="M34.061,68.122A34.061,34.061,0,1,1,34.061,0"
                  transform="translate(859.428 1132.373) rotate(180)"
                  fill="none"
                  stroke="#0057b7"
                  strokeMiterlimit="10"
                  strokeWidth="10"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div className="hidden lg:block">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98.774 99.629">
          <g
            id="Group_1134"
            data-name="Group 1134"
            transform="translate(-773.57 -931.842)"
          >
            <g
              id="Group_662"
              data-name="Group 662"
              transform="translate(756.326 163.786)"
            >
              <text
                id="_50_"
                data-name="50%"
                transform="translate(52.273 815.187)"
                fill="#fff"
                fontSize="17.2"
                className="waldo-sans font-normal text-h_5"
                letterSpacing="0.04em"
              >
                <tspan x="0" y="0">
                  50%
                </tspan>
              </text>
              <text
                id="patients"
                transform="translate(46.774 827.935)"
                fill="#fff"
                fontSize="12"
                className="waldo-sans font-semibold text-xs"
              >
                <tspan x="0" y="0">
                  patients
                </tspan>
              </text>
            </g>
            <g id="Group_1133" data-name="Group 1133">
              <g
                id="Group_1024"
                data-name="Group 1024"
                transform="translate(0 -116.655)"
              >
                <g
                  id="Group_665"
                  data-name="Group 665"
                  transform="translate(759.07 290.245)"
                  opacity="0.5"
                >
                  <path
                    id="Path_677"
                    data-name="Path 677"
                    d="M48.887,0A49.317,49.317,0,1,1,0,49.315,49.1,49.1,0,0,1,48.887,0Z"
                    transform="translate(15 758.752)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="1"
                  />
                </g>
                <path
                  id="Path_436"
                  data-name="Path 436"
                  d="M-341.939,8.122A34.061,34.061,0,0,1-376-25.939,34.061,34.061,0,0,1-341.939-60"
                  transform="translate(1164.486 1124.25)"
                  fill="none"
                  stroke="#fff"
                  strokeMiterlimit="10"
                  strokeWidth="15"
                />
                <path
                  id="Path_746"
                  data-name="Path 746"
                  d="M34.061,68.122A34.061,34.061,0,1,1,34.061,0"
                  transform="translate(859.428 1132.373) rotate(180)"
                  fill="none"
                  stroke="#0057b7"
                  strokeMiterlimit="10"
                  strokeWidth="10"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};
